
(function (window, angular, undefined) {

    function getUrlParameter(name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        var results = regex.exec(location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    }

    var route = getUrlParameter('journeyType');

    angular.module('formApp').constant('requestedRoute', {
        routeName: route
      }).config(['$stateProvider','$locationProvider', '$urlRouterProvider', '$urlMatcherFactoryProvider', '$httpProvider', 'API_PATH', 'requestedRoute',
        function ($stateProvider, $locationProvider, $urlRouterProvider, $urlMatcherFactoryProvider, $httpProvider, apiPath,requestedRoute) {
            // add loading spinner service
            $httpProvider.interceptors.push('LoadingInterceptor');
            $urlMatcherFactoryProvider.strictMode(false);

                if(requestedRoute.routeName === 'combined' || requestedRoute.routeName === 'combined2' || sessionStorage.getItem('journeyType') === 'combined' || sessionStorage.getItem('journeyType') === 'combined2'){
                    var name = getUrlParameter('petName');
                    var type = getUrlParameter('petvalue');
                    var breed = getUrlParameter('breed');
                    
                    if((name && type) && breed){
                        route = 'step-1-2?petName='+name+'&petvalue='+type+'&breed='+breed;
                    }
                    else{
                        route = 'step-1-2';
                    }
                    if (requestedRoute.routeName) {
                        sessionStorage.setItem("journeyType",requestedRoute.routeName);
                    }
                }
                else{
                    route = 'step-1';
                    sessionStorage.setItem("journeyType","single"); 
                }
                if(requestedRoute.routeName === 'review'){
                    sessionStorage.setItem("tandtDetailsTest","true"); 
                }
                if(requestedRoute.routeName === 'captcha'){
                    sessionStorage.setItem("tandtCaptchaTest","true"); 
                }
         
            // This is the view that is displayed when the app initially loads - only do it if we're not in an iframe
            if (document.referrer.indexOf('editor.html') === -1) { // not in editor.html
                if (apiPath === 'sa/cn') {
                    $urlRouterProvider.otherwise('ecover/retrieve');
                } else {
                    $urlRouterProvider.otherwise(route);
                }
                $locationProvider.html5Mode(true).hashPrefix('!');
            }

            var error404 = {
                name: 'error-404',
                url: '/404',
                params: {
                    forward: null,
                    type: null,
                    petToEdit: null,
                    step: 'error-404'
                },
                templateUrl: '/content/ah_small-animal/step-views/404/jcr:content/main.html',
                controller: 'errorCtrl'
            };

            var stepOne = {
                name: 'step-1',
                url: '/step-1',
                params: {
                    forward: null,
                    type: null,
                    petToEdit: null,
                    step: 'step-one'
                },
                templateUrl: '/content/ah_small-animal/step-views/step-one/jcr:content/main.html',
                controller: 'stepOneCtrl'
            };

            var stepOneTwo = {
                name: 'step-1-2',
                url: '/step-1-2',
                params: {
                    forward: null,
                    type: null,
                    petToEdit: null,
                    step: 'step-one-two'
                },
                templateUrl: '/content/ah_small-animal/step-views/step-one-two/jcr:content/main.html',
                controller: 'stepOneTwoCtrl',
            };

            var stepTwo = {
                name: 'step-2',
                url: '/step-2',
                params: {
                    forward: null,
                    type: null,
                    step: 'step-two'
                },
                templateUrl: '/content/ah_small-animal/step-views/step-two/jcr:content/main.html',
                controller: 'stepTwoCtrl'
            };

            var stepThree = {
                name: 'step-3',
                url: '/step-3',
                params: {
                    forward: null,
                    type: null,
                    petId: null,
                    position: null,
                    retrieve: null,
                    step: 'step-three',
                    quote: false
                },
                templateUrl: '/content/ah_small-animal/step-views/step-three/jcr:content/main.html',
                controller: 'stepThreeCtrl'
            };

            var stepThreeSelect = {
                name: 'step-3-select',
                url: '/step-3/:id/:selectState',
                params: {
                    forward: null,
                    type: null,
                    petId: null,
                    position: null,
                    retrieve: null,
                    step: 'step-three',
                    quote: false
                },
                templateUrl: '/content/ah_small-animal/step-views/step-three/jcr:content/main.html',
                controller: 'stepThreeCtrl'
            };

            var stepFour = {
                name: 'step-4',
                url: '/step-4',
                params: {
                    forward: null,
                    type: null,
                    step: 'step-four'
                },
                templateUrl: '/content/ah_small-animal/step-views/step-four/jcr:content/main.html',
                controller: 'stepFourCtrl'
            };

            var stepFourEq = {
                name: 'step-4e',
                url: '/equote/step-4',
                params: {
                    forward: null,
                    type: null,
                    step: 'step-four'
                },
                templateUrl: '/content/ah_small-animal/step-views/step-four/jcr:content/main.html',
                controller: 'stepFourCtrl'
            };         

            var stepFive = {
                name: 'step-5',
                url: '/step-5',
                params: {
                    forward: null,
                    type: null,
                    petToEdit: null,
                    step: 'step-five'
                },
                templateUrl: '/content/ah_small-animal/step-views/step-five/jcr:content/main.html',
                controller: 'stepFiveCtrl'
            };
            var stepFiveDetails = {
                name: 'step-5-details',
                url: '/step-5-details',
                params: {
                    forward: null,
                    type: null,
                    petToEdit: null,
                    step: 'step-five-details'
                },
                templateUrl: '/content/ah_small-animal/step-views/step-five-details/jcr:content/main.html',
                controller: 'stepFiveCtrl'
            };

            var stepFiveEq = {
                name: 'step-5e',
                url: '/equote/step-5',
                params: {
                    forward: null,
                    type: null,
                    petToEdit: null,
                    step: 'step-five'
                },
                templateUrl: '/content/ah_small-animal/step-views/step-five/jcr:content/main.html',
                controller: 'stepFiveCtrl'
            };

            var stepSix = {
                name: 'step-6',
                url: '/step-6',
                params: {
                    forward: null,
                    type: null,
                    step: 'step-six'
                },
                templateUrl: '/content/ah_small-animal/step-views/step-six/jcr:content/main.html',
                controller: 'stepSixCtrl'
            };

            var stepSixEq = {
                name: 'step-6e',
                url: '/equote/step-6',
                params: {
                    forward: null,
                    type: null,
                    step: 'step-six'
                },
                templateUrl: '/content/ah_small-animal/step-views/step-six/jcr:content/main.html',
                controller: 'stepSixCtrl'
            };

            var retrieveQuote = {
                name: 'retrieve-quote',
                url: '/retrieve-quote',
                params: {
                    forward: null,
                    type: null,
                    step: 'step-retrieve'
                },
                templateUrl: '/content/ah_small-animal/step-views/retrieve-quote/jcr:content/main.html',
                controller: 'retrieveQuoteCtrl'
            };

            var altRetrieveQuote = {
                name: 'alt-retrieve-quote',
                url: '/retrieve-quote/2',
                params: {
                    forward: null,
                    type: null,
                    step: 'step-retrieve'
                },
                templateUrl: '/content/ah_small-animal/step-views/alt-retrieve-quote/jcr:content/main.html',
                controller: 'retrieveQuoteCtrl'
            };
            
            var eQuote = {
                name: 'equote',
                url: '/equote',
                params: {
                    forward: null,
                    type: null,
                    step: 'step-retrieve'
                },
                templateUrl: '/content/ah_small-animal/step-views/retrieve-equote/jcr:content/main.html',
                controller: 'retrieveEquoteCtrl'
            };

            var error = {
                name: 'error',
                url: '/error',
                params: {
                    forward: null,
                    etype: null,
                    message: null,
                    rid: null,
                    sid: null,
                    step: 'step-error'
                },
                templateUrl: '/content/ah_small-animal/step-views/error/jcr:content/main.html',
                controller: 'errorCtrl'
            };


            var retrieveError = {
                name: 'retrieve-error',
                url: '/retrieve-error',
                params: {
                    forward: null,
                    type: null,
                    message: null,
                    rid: null,
                    sid: null,
                    step: 'step-error'
                },
                templateUrl: '/content/ah_small-animal/step-views/retrieve-error/jcr:content/main.html',
                controller: 'errorCtrl'
            };

            var retrieveExpired = {
                name: 'retrieve-expired',
                url: '/retrieve-expired',
                params: {
                    forward: null,
                    type: null,
                    step: 'step-retrieve-expired'
                },
                templateUrl: '/content/ah_small-animal/step-views/retrieve-expired/jcr:content/main.html',
                controller: 'retrieveQuoteCtrl'
            };

            var eCover = {
                name: 'ecover',
                data: {
                    app:  "eCoverNote"
                }
            };

            var retrieveEcover = {
                name: 'retrieve-ec',
                url: '/ecover/retrieve',
                params: {
                    forward: null,
                    type: null,
                    step: 'step-retrieve'
                },
                templateUrl: '/content/ah_small-animal/step-views/retrieve-ecover/jcr:content/main.html',
                controller: 'retrieveEcoverController',
                parent: eCover
            }; 
            
            var retrieveEcover2 = {
                name: 'retrieve-ec-2',
                url: '/ecover/retrieve-2',
                params: {
                    forward: null,
                    type: null,
                    step: 'step-retrieve-2',
                    app: "eCoverNote2"
                },
                templateUrl: '/content/ah_small-animal/step-views/retrieve-ecover-2/jcr:content/main.html',
                controller: 'retrieveEcoverController',
                parent: eCover
            }; 

            var altRetrieveEcover = {
                name: 'alt-retrieve-ec',
                url: '/ecover/retrieve/2',
                params: {
                    forward: null,
                    type: null,
                    step: 'alt-step-retrieve'
                },
                templateUrl: '/content/ah_small-animal/step-views/alt-retrieve-ecover/jcr:content/main.html',
                controller: 'retrieveEcoverController',
                parent: eCover
            };

            var petDetailsEcover = {
                name: 'details-ec',
                url: '/ecover/details',
                params: {
                    forward: null,
                    step: 'step-activate'
                },
                templateUrl: '/content/ah_small-animal/step-views/activate-ecover/jcr:content/main.html',
                controller: 'activateEcoverController',
                parent: eCover
            };

            var quoteEcover = {
                name: 'quote-ec',
                url: '/ecover/quote',
                params: {
                    forward: null,
                    step: 'step-three'
                },
                templateUrl: '/content/ah_small-animal/step-views/step-three/jcr:content/main.html',
                controller: 'stepThreeCtrl',
                parent: eCover
            };

            var quoteEcoverSelect = {
                name: 'quote-ec-select',
                url: '/ecover/quote/:id/:selectState',
                params: {
                    forward: null,
                    step: 'step-three'
                },
                templateUrl: '/content/ah_small-animal/step-views/step-three/jcr:content/main.html',
                controller: 'stepThreeCtrl',
                parent: eCover
            };
            
            var questionsEcover = {
                name: 'questions-ec',
                url: '/ecover/questions',
                params: {
                    forward: null,
                    step: 'step-four'
                },
                templateUrl: '/content/ah_small-animal/step-views/step-four/jcr:content/main.html',
                controller: 'stepFourCtrl',
                parent: eCover
            };

            var payEcover = {
                name: 'pay-ec',
                url: '/ecover/pay',
                params: {
                    forward: null,
                    step: 'step-five'
                },
                templateUrl: '/content/ah_small-animal/step-views/step-five/jcr:content/main.html',
                controller: 'stepFiveCtrl',
                parent: eCover
            };
            
            var confirmEcover = {
                name: 'confirm-ec',
                url: '/ecover/confirmation',
                params: {
                    forward: null,
                    step: 'step-six'
                },
                templateUrl: '/content/ah_small-animal/step-views/step-six/jcr:content/main.html',
                controller: 'stepSixCtrl',
                parent: eCover
            };

            var retrieveEcError = {
                name: 'retrieve-ec-error',
                url: '/ecover/retrieve-error',
                params: {
                    forward: null,
                    etype: null,
                    message: null,
                    rid: null,
                    sid: null,
                    step: 'step-error'
                },
                templateUrl: '/content/ah_small-animal/step-views/retrieve-ecover-error/jcr:content/main.html',
                controller: 'errorCtrl',
                parent: eCover
            };

            var techError = {
                name: 'tech-error',
                url: '/tech-error',
                params: {
                    forward: null,
                    step: 'tech-error'
                },
                templateUrl: '/content/ah_small-animal/step-views/tech-error/jcr:content/main.html',
                controller: 'errorCtrl'
            };

            var covernote = {
                name: 'covernote',
                url: '/covernote',
                params: {
                    forward: null,
                    step: 'covernote'
                },
                templateUrl: '/content/ah_small-animal/step-views/covernote/jcr:content/main.html',
                controller: 'covernoteCtrl'
            };

            if(apiPath === 'sa/cn') {                
                $stateProvider.state(petDetailsEcover);
                $stateProvider.state(quoteEcover);
                $stateProvider.state(quoteEcoverSelect);
                $stateProvider.state(questionsEcover);
                $stateProvider.state(payEcover);
                $stateProvider.state(confirmEcover);
                $stateProvider.state(retrieveEcError);
                $stateProvider.state(retrieveEcover);
                $stateProvider.state(retrieveEcover2);
                $stateProvider.state(eCover);
                $stateProvider.state(error);
                $stateProvider.state(error404);
                $stateProvider.state(altRetrieveEcover);
            } else {
                $stateProvider.state(stepOne);
                $stateProvider.state(stepOneTwo);
                $stateProvider.state(stepTwo);
                $stateProvider.state(stepThree);
                $stateProvider.state(stepThreeSelect);
                $stateProvider.state(stepFour);
                $stateProvider.state(stepFourEq);
                $stateProvider.state(stepFive);
                $stateProvider.state(stepFiveDetails);
                $stateProvider.state(stepFiveEq);
                $stateProvider.state(stepSix);
                $stateProvider.state(stepSixEq);
              $stateProvider.state(altRetrieveQuote);
                $stateProvider.state(retrieveQuote);
                $stateProvider.state(eQuote);
                $stateProvider.state(error);
                $stateProvider.state(error404);
                $stateProvider.state(retrieveError);
                $stateProvider.state(retrieveExpired);
                $stateProvider.state(techError);
                $stateProvider.state(covernote);
            }

        }])
        .service('stateService', ['API_PATH', function (apiPath) {
            if(apiPath === 'sa/cn') {
                this.states = [
                    'details-ec',
                    'quote-ec-select',
                    'quote-ec',
                    'questions-ec',
                    'pay-ec',
                    'confirm-ec',
                    'error',
                    'error-404',
                    'retrieve-ec-error'
                ];
            } else {
                this.states = [
                    'step-1',
                    'step-1-2',
                    'step-2',
                    'step-3-select',
                    'step-3',
                    'step-4',
                    'step-4e',
                    'step-5',
                    'step-5e',
                    'step-6',
                    'step-6e',
                    'error',
                    'error-404',
                    'retrieve-error',
                    'retrieve-expired',
                    'tech-error',
                    'covernote'
                ];
            }
            this.complete = false;
        }])
        .run(['$location', '$window', 'requestedRoute','$transitions','$anchorScroll', '$rootScope', 'stateService', '$state', function ($location,$window,requestedRoute,$transitions,$anchorScroll, $rootScope, stateService, $state) {
  
            if($location.$$url==='/retrieve-quote/2' || $location.$$url==='/ecover/retrieve/2'){
                $rootScope.altRetrieveEcover = true;
            }   
            var route;
            if(requestedRoute.routeName === 'combined' || requestedRoute.routeName === 'combined2'){
                route = 'step-1-2';
                $rootScope.mainJourney = false;
            }
            else{
                route = 'step-1';
                $rootScope.mainJourney = true;
            }
            if($location.$$url==='/404'){
                route = 'error-404';
                $rootScope.mainJourney = false;
            }
            if($location.$$url==='/retrieve-expired'){
                route = 'retrieve-expired';
                $rootScope.retrieveExpired = true;
            }  
            if($location.$$url==='/tech-error'){
                route = 'tech-error';
                $rootScope.techError = true;
            }
            if ($location.$$url.includes('/covernote')){
                route = 'covernote';
                $rootScope.covernote = true;
            }
            $transitions.onSuccess({}, function (transition) {
                $rootScope.app = transition.to().data && transition.to().data.app;
                $rootScope.eCoverNote = $rootScope.app === 'eCoverNote' || $rootScope.app === 'eCoverNote2';
                $anchorScroll();
            });
            // prevent going straight to step-5
            // TODO develop further for proper flow through app
            $transitions.onStart({}, function (transition) {

                var from = transition.from().name,
                    to = transition.to().name,
                    sessionState = sessionStorage.getItem('currentRefreshState');
                
                if (from === '' && to !== route && to !== 'retrieve-quote' && to !== 'alt-retrieve-quote' && to !== 'equote' && to !== 'retrieve-ec' && to !== 'retrieve-ec-2' && to !== 'alt-retrieve-ec' ) {
                    // not from nav/app
                    if (!sessionState || stateService.states.indexOf(sessionState) === -1) {
                        if(transition.to().data && transition.to().data.app === 'eCoverNote') {
                            return transition.router.stateService.target('retrieve-ec');
                        } else if (transition.to().data && transition.to().data.app === 'eCoverNote2') {
                            return transition.router.stateService.target('retrieve-ec-2');
                        } else {
                            return transition.router.stateService.target(route);
                        }
                    }
                    if (sessionState && stateService.states.indexOf(to) > stateService.states.indexOf(sessionState)) {
                        return transition.router.stateService.target(sessionState);
                    }
                }

                if (stateService.states.indexOf(from) !== -1) {
                    return canMove(transition);
                }
            });

            function canMove(transition) {
                var from = transition.from().name,
                    to = transition.to().name,
                    forwards = stateService.states.indexOf(from) < stateService.states.indexOf(to),
                    backwards = !forwards;

                    // if(sessionStorage.getItem('retrieveQuote') === 'true' && backwards === true && transition.to().name === 'step-1' || sessionStorage.getItem('retrieveQuote') === 'true' && backwards === true && transition.to().name === 'step-2' ){
                    //     return false;
                    // }
                    // if(sessionStorage.getItem('eQuote') === 'true' && backwards === true && transition.to().name === 'step-1' || sessionStorage.getItem('eQuote') === 'true' && backwards === true && transition.to().name === 'step-2'){
                    //     return false;
                    // }

                return transition.to().name === 'error' || (!stateService.complete && (backwards || (forwards && !!transition.params().forward)));
                //   return true;  // no restriction on menu navigation
            }
        }]);
})(window, window.angular);